import { database } from './firebase.js'

function Tags() {

  let tags = []

  var ref = database.ref(`tags`)

  ref.on('value', function(snapshot) {
    // rewrite values:
    tags.length = 0
    tags.merge( Object.values(snapshot.val()) )
  })

  tags.saveNewTags = (newTags) => {
    let difference = newTags.filter(x => !tags.includes(x))
    difference.each(newTag => {
      var tagRef = ref.push()
      tagRef.set(newTag)
    })
  }

  return tags
}

export default new Tags()



// WEBPACK FOOTER //
// ./src/services/firebase/tags.js